
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useLoginForm } from './useLoginForm';
import { useNavigate, Link } from 'react-router-dom';

interface LoginFormProps {
  onToggleForm: () => void;
  savedEditPath: string | null;
  fromPath: string;
}

export const LoginForm: React.FC<LoginFormProps> = ({ 
  onToggleForm, 
  savedEditPath,
  fromPath
}) => {
  const { 
    email, 
    setEmail, 
    password, 
    setPassword, 
    isLoading, 
    error, 
    handleSubmit 
  } = useLoginForm(savedEditPath, fromPath);
  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit} className="space-y-4 relative">
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
        />
      </div>

      {error && <p className="text-sm text-red-500">{error}</p>}

      <div className='w-full relative pb-5'>
        <Link
          to="/reset-password"
          className="absolute right-0 text-sm text-right underline"
        >
          Forgot Password?
        </Link>
      </div>

      <Button type="submit" className="w-full mt-5" disabled={isLoading}>
        {isLoading ? 'Processing...' : 'Login'}
      </Button>
      
      <Button
        type="button"
        variant="link"
        className="w-full"
        onClick={onToggleForm}
        disabled={isLoading}
      >
        Need an account? Register
      </Button>
    </form>
  );
};
